import { render } from "./ProductCategoriesTabsComponent.vue?vue&type=template&id=a99e0762&scoped=true"
import script from "./ProductCategoriesTabsComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoriesTabsComponent.vue?vue&type=script&lang=js"

import "./ProductCategoriesTabsComponent.vue?vue&type=style&index=0&id=a99e0762&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99e0762"],['__file',"platform/themes/staderecord/assets/js/components/ProductCategoriesTabsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a99e0762"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a99e0762', __exports__)) {
    api.reload('a99e0762', __exports__)
  }
  
  module.hot.accept("./ProductCategoriesTabsComponent.vue?vue&type=template&id=a99e0762&scoped=true", () => {
    api.rerender('a99e0762', render)
  })

}


export default __exports__